interface IGetCategorySubCategoryKey {
  category: string
  subCategory: string
}

export const getCategorySubCategoryKey = ({
  category,
  subCategory,
}: IGetCategorySubCategoryKey) => {
  return `${category}-${subCategory}`
}
